import React, { useCallback } from 'react';
import { Field } from 'react-final-form';
import Filter from '../Filter';

const FiltersField = ({
  filters,
  selectedKey,
  openFromRight,
  name,
  validate,
  setFilters,
  onChange,
  showIcon,
  disableTooltip,
  usePortal
}) => {
  const fieldValidate = useCallback(() => validate?.(filters), [filters, validate]);
  return (
    <Field
      name={name}
      validate={fieldValidate}
      render={({ input, meta }) => {
        return (
          <Filter
            {...input}
            value={input.value}
            onChange={(value) => {
              if (onChange) {
                onChange(value, input);
              } else {
                input.onChange(value);
              }
            }}
            maxHeight={175}
            selectedKey={selectedKey}
            filters={filters}
            setFilters={setFilters}
            showIcon={showIcon}
            openFromRight={openFromRight}
            disableTooltip={disableTooltip}
            usePortal={usePortal}
            error={meta.touched && meta.error}
          />
        );
      }}
    />
  );
};

export default FiltersField;
